export default __webpack_public_path__ + "static/media/Share-black.3faa2d9d.svg";